<template>
  <Multiselect
    v-model="selected"
    :options="options"
    :label="label"
    track-by="value"
    @input="handleSelect"
    :placeholder="placeholder"
    selectLabel="請選擇"
    selectedLabel="（已勾選）"
    deselectLabel="取消勾選"
    :disabled="disabled"
    :id="id"
    class="app-single-select"
    :class="{ 'app-single-select--has-error': hasError }"
    :allowEmpty="clearable"
  >
    <span slot="noOptions">
      <div>查無資料</div>
    </span>
  </Multiselect>
</template>

<script>
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";

export default {
  props: {
    value: Object,
    options: Array,
    label: {
      type: String,
      default: "text",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: "輸入查詢",
    },
    hasError: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      required: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Multiselect,
  },
  computed: {
    selected: {
      get() {
        return this.value;
      },
      set() {
        // this.$emit("input", v);
      },
    },
  },
  methods: {
    handleSelect(v) {
      this.$emit("input", v);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep.app-single-select--has-error {
  .multiselect__tags {
    border-color: #fe0000;
  }
}
</style>
